import React, { useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import { chartImageScaleFactor, defaultAreaId } from "../../../constants";
import exportCharts from "../../multipleChartExporting";
import AreaChooser from "../../choosers/AreaChooser";
import ChangeInMethodMixChart from "./ChangeInMethodMixChart";
import DataViewerFrame from "../../widgets/DataViewerFrame";

const ChangeInMethodMixChartWidget = props => {
  const [areaId, setAreaId] = useState(defaultAreaId);

  const chartRefs = {};

  return (
    <DataViewerFrame
      dataViewerId="change_in_method_mix_chart"
      reference="Figure 5.2"
      title="Percentage Point Change in Method Mix, 2020–2030"
      filters={[
        <AreaChooser
          id="figure-5-2"
          label="Select Country or Country Group"
          areas={props.database.areas}
          includeCountries={true}
          selectedKey={areaId}
          onChange={areaId => {
            setAreaId(areaId);

            props.onChange({
              widget: "theme5.changeInMethodMixChart",
              payload: {
                areaId
              }
            });
          }}
        />
      ]}
      onDownloadCsv={() => {
        props.onDownloadCsv({
          area: props.database.areas[areaId].area
        });
      }}
      onDownloadPng={() => {
        exportCharts(chartRefs, {
          filename: "change_in_method_mix_chart",
          scale: chartImageScaleFactor
        });
      }}
    >
      <ChangeInMethodMixChart
        data={props.data}
        onRegisterChartRef={(key, ref) => {
          if (ref) {
            chartRefs[key] = ref;
          } else {
            delete chartRefs[key];
          }
        }}
      />
    </DataViewerFrame>
  );
};

ChangeInMethodMixChartWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onDownloadCsv: PropTypes.func.isRequired
};

export default ChangeInMethodMixChartWidget;
